import script from "./NavigationView.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationView.vue?vue&type=script&setup=true&lang=js"

import "./NavigationView.vue?vue&type=style&index=0&id=b385b048&scoped=true&lang=css"
import "./NavigationView.vue?vue&type=style&index=1&id=b385b048&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b385b048"]])

export default __exports__